import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "emailId", "faxId", "addressId", "methodField", "secureToggleWrapper"]

  change() {
    const opt = this.selectTarget.options[this.selectTarget.selectedIndex]
    this.emailIdTarget.value = opt.dataset.emailId || ""
    this.faxIdTarget.value = opt.dataset.faxId || ""
    this.addressIdTarget.value = opt.dataset.addressId || ""
    this.methodFieldTarget.value = opt.dataset.method
    this.secureToggleWrapperTarget.classList.toggle("hidden", opt.dataset.method !== "email")
    this.dispatch("methodChanged")
  }
}
